export default function Logo({ size = 36, withText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="alpha-logo">
      <svg width={size} height={size} viewBox="0 0 100 100" className="flex-shrink-0">
        <defs>
          <linearGradient id="garnetGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FF4060" />
            <stop offset="100%" stopColor="#880015" />
          </linearGradient>
          <filter id="neonGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <polygon
          points="50,12 88,88 70,88 60,70 40,70 30,88 12,88"
          fill="none"
          stroke="url(#garnetGrad)"
          strokeWidth="6"
          strokeLinejoin="miter"
          filter="url(#neonGlow)"
        />
        <line x1="42" y1="58" x2="58" y2="58" stroke="url(#garnetGrad)" strokeWidth="5" filter="url(#neonGlow)" />
      </svg>
      {withText && (
        <div className="leading-none">
          <div className="font-display font-black text-white text-base tracking-tight">ALPHA</div>
          <div className="font-display font-light text-white/60 text-[10px] tracking-[0.4em]">AUDIOS</div>
        </div>
      )}
    </div>
  );
}
